(function () {
    'use strict';
    angular.module('Directives').directive('bbaDriverChatPanel', bbaDriverChatPanel);
    bbaDriverChatPanel.$inject = [
        'toastr',
        '$timeout',
        'FleetService',
        '$rootScope',
        '$filter'
    ];

    function bbaDriverChatPanel(
        toastr,
        $timeout,
        FleetService,
        $rootScope,
        $filter
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/driver-chat/bbaDriverChatPanel.html',
            scope: {
                socketConnection: '=',
                data: '=',
                newMessage: '=',
                removeChatHeadCallback: '=',
                viewMessageCallback: '='
            },
            link: bbaDriverChatPanelLink
        }

        function bbaDriverChatPanelLink(scope, elems, attr) {
            let currentPage = 0;
            let totalPages = 1;
            let first = false;
            let last  = false;

            scope.showPanelBody = true;
            scope.sendMessage = sendMessage;
            scope.togglePanel = togglePanel;

            init();
            function init(){
                removeViewedMessage(scope.data);
                initializeInifiniteScrolll();
                loadMessageData();
                watchNewMessage();
            }

            function watchNewMessage(){
                scope.$watch('newMessage', function(msg){
                    if(msg != undefined) {
                        removeViewedMessage(msg);
                        if(scope.data.id == msg.jobId){
                            loadMessageData();
                        }
                    }
                });
            }

            function initializeInifiniteScrolll(){
                $timeout(function () {
                    let messagesElem = angular.element(document.querySelector('#messages'));
                    messagesElem[0].scrollTop = messagesElem[0].scrollHeight;
                    messagesElem[0].addEventListener('scroll', function (e) {
                        const elem = angular.element(this);
                        const elemScrollPos = elem[0].scrollTop;
                        if(elemScrollPos == 0) {
                            if(totalPages > 1 && !last) {
                                currentPage = currentPage + 1;
                                loadMessageData();
                            }
                        }
                        
                        if(elemScrollPos + elem[0].clientHeight == elem[0].scrollHeight) {
                            if(totalPages > 1 && !first) {
                                currentPage = currentPage - 1;
                                loadMessageData();
                            }
                        }
                    });
                }, 1000);
            }

            function loadMessageData(){
                scope.loading = true;
                FleetService.Chat.chatHistory(scope.data.id, data => {
                    const loadedMessages = data.content.map(msg=>{
                        return {
                            createdDate: $filter('bbaDate')(msg.createdDate, true),
                            message: msg.message,
                            sender: $rootScope.GlobalProfile.email == msg.sender ? true : false
                        }
                    }).reverse();
                    scope.messagesData = loadedMessages;
                    
                    currentPage = data.number;
                    totalPages = data.totalPages;
                    first = data.first;
                    last = data.last;
                    scope.loading = false;
                }, error => {
                    toastr.error(error.message, 'Error');
                    scope.loading = false;
                }, {
                    size: 10,
                    sort: 'id,desc',
                    page: currentPage
                });
            }

            function sendMessage(){
                const chatMsgInputElem = angular.element(document.querySelector(`#chatMsgform_${scope.data.id}`));
                const msg = chatMsgInputElem[0].value;

                if(msg != "" && msg != null) {
                    scope.sendingMessage = true;
                    FleetService.Chat.sendMessage(scope.data.id, msg, ()=>{
                        loadMessageData();
                        scope.sendingMessage = false;
                        chatMsgInputElem[0].value = null;
                    }, error=>{
                        scope.sendingMessage = false;
                        toastr.error(error.message, "Cannot Send Message");
                    });
                }
            }

            function togglePanel() {
                scope.showPanelBody = !scope.showPanelBody;
            }

            function removeViewedMessage(){
                if(scope.showPanelBody) {
                    const storedNewMsg = JSON.parse(localStorage.getItem('new-messages'));
                    if(storedNewMsg) { 
                        const msgsTobeStored = storedNewMsg.filter(msg => {
                            return msg.jobId != scope.data.id; 
                        });

                        if(msgsTobeStored.length == 0) {
                            localStorage.removeItem('new-messages');
                        }
                        else {
                            localStorage.setItem('new-messages', JSON.stringify(msgsTobeStored));
                        }
                    }
                    scope.viewMessageCallback(scope.data);
                }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/driver-chat/bbaDriverChatPanel.js